<template>
    <main>
        <fade-transition :duration="{enter: 500, leave: 10}" mode="out-in" appear>
            <router-view></router-view>
        </fade-transition>
    </main>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    import {stateValidator} from "../mixins/routes/editor";
    import {menusMixin} from "../mixins/menus";

    export default {
        components: {FadeTransition},
        mixins: [stateValidator, menusMixin],
        computed: {
            ...mapGetters('editors', [
                'editor',
                'reel',
                'media',
            ])
        },
        created() {
            this.onRefresh()
        },
        mounted() {
            //console.log('editor: mounted')
        },
        watch: {
            '$route': 'onRefresh'
        },
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            onRefresh() {
                //console.log('editor: refresh', this.$route)
                this.$store.dispatch('editors/initEditorState', this.$route.params)
                this.$_redirectIfFail()
                //debugger
                this.setSeo(this.editor.seo)
                this.$scrollTo('body')
            },
        }
    }
</script>
